/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Button, Modal } from "semantic-ui-react";

const AlertModal = ({ alertModalState, setAlertModalState }) => {
  const modalClose = () => {
    setAlertModalState(prevState => { return { ...prevState, "open": false }; });
  }

  useEffect(() => {
    window.addEventListener('keyup', (e) => { if (e.key === "Enter") { modalClose(); } }, false);
  }, []);

  useEffect(() => {
    if (alertModalState.open) {
      setAlertModalState(prevState => { return { ...prevState, alertHistory: [...prevState.alertHistory, { header: prevState.header, content: prevState.content }] }; });
    }
  }, [alertModalState.open]);


  return <Modal
    style={{ width: "60%", margin: "16px" }}
    dimmer={<Modal.Dimmer blurring style={{ backgroundColor: "#00000077" }} />}
    open={alertModalState.open}
    centered={false}
    content={<div style={{ whiteSpace: "pre-wrap" }} onKeyUp={(e) => { if (e.key === "Enter") { modalClose(); } }}>
      <Button style={{ padding: "6px", position: "absolute", top: "6px", right: "6px" }} className="formButton negative" content="✖"
        onClick={modalClose} />
      <Modal.Header style={{ padding: "6px 16px 0px 16px", color: "#AC3B61" }}><h2>{alertModalState.header}</h2></Modal.Header>
      <br />
      <div style={{ padding: "0px 16px 0px 16px" }}>
        {alertModalState.content && <><h3>{alertModalState.content}</h3><br /></>}
        <br />
      </div>
    </div>}
    closeOnEscape
    closeOnDimmerClick
    onClose={modalClose}
  />
}

export default AlertModal;